module.exports = __webpack_public_path__ + "static/ALLEGATO34-0275c706a497d3e5796c691c2da76c86.pdf";